import React from 'react';
import Head from 'next/head';
import { LoginFlowContainer } from '../../auth';
import { withFlagshipSession } from '../../auth/withFlagshipSession';
import { MetaAttributes } from '../../head';
import { shared } from '../../config';

const LoginPage = () => {
  return (
    <>
      <Head>
        <script
          type="text/javascript"
          src={`${shared.AWS_WAF_CHALLENGE_INTEGRATION_URL}`}
          defer
        />
      </Head>
      <MetaAttributes seoTitle="Login | Ollie" />
      <LoginFlowContainer />
    </>
  );
};

export const getServerSideProps = withFlagshipSession(async context => {
  return {
    props: {},
  };
});

LoginPage.displayName = 'LoginPage';

export default LoginPage;
